import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosCatalog';

export const getTechnologyType = createAsyncThunk(
  '/getTechnologyType',
  
  async () => {
    const response = await axios.get('/GetTechnologyType');
    return response.data;
  }
);

export const getTechnologyTypeDetails = createAsyncThunk(
  '/getTechnologyTypeDetails',
  async (id) => {
    const response = await axios.get(`/GetTechnologyTypeDetails/${id}`);
    return response.data;
  }
);

export const getLanguagelist = createAsyncThunk(
  '/getLanguageList',
  async () => {
    const response = await axios.get('/GetLanguageList');
    return response.data;
  }
);

const technologyTypeSlice = createSlice({
  name: 'technologyType',
  initialState: {
    loading: false,
    error: '',
    technologyType: [],
    technologyTypeDescriptions: [],
    SelectedAppTranslationId: 0,
    IsChecked: true,
    response: ''
  },
  reducers: {
    changeSelectedAppTranslationId(state, action) {
      state.SelectedAppTranslationId = action.payload;
    },

    resetDescriptions(state) {
      state.technologyTypeDescriptions = [];
    },
    changeIsChecked(state, action) {
      state.IsChecked = action.payload;
    }
  },

  extraReducers: {
    [getTechnologyType.pending]: (state) => {
      state.loading = true;
    },
    [getTechnologyType.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getTechnologyType.fulfilled]: (state, action) => {
      state.technologyType = action.payload;
      state.loading = false;
    },
    [getTechnologyTypeDetails.pending]: (state) => {
      state.loading = true;
    },
    [getTechnologyTypeDetails.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getTechnologyTypeDetails.fulfilled]: (state, action) => {
      state.technologyTypeDescriptions = action.payload;
      state.loading = false;
    },
    [getLanguagelist.pending]: (state) => {
      state.loading = true;
    },
    [getLanguagelist.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getLanguagelist.fulfilled]: (state, action) => {
      state.technologyTypeDescriptions = action.payload;
      state.loading = false;
    }
  }
});

export const technologyTypeActions = technologyTypeSlice.actions;

export default technologyTypeSlice;
